
























































































































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import Endereco from "./dados-basicos/Endereco.vue";
import Telefones from "./dados-basicos/Telefones.vue";
import ContaBancaria from "./dados-basicos/ContaBancaria.vue";
import { DadosBasicosController, DadosBasicosPrestadorModel, TipoPessoa } from "@/models/cadastros/saude/DadosBasicosPrestadorModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { tiposPrestadorList } from "@/models/cadastros/saude/TipoPrestadorModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import { ValidationResult } from "vee-validate/dist/types/types";

@Component({
  components: {
    Endereco,
    Telefones,
    ContaBancaria,
  },
})
export default class DadosBasicos extends Vue {
  $refs!: {
    dadosBasicosObserver: InstanceType<typeof ValidationObserver>;
    telefones: InstanceType<typeof Telefones>;
  };

  @Ref()
  DocProvider!: InstanceType<typeof ValidationProvider>;

  @Prop({ required: true })
  dadosBasicos!: DadosBasicosPrestadorModel;

  @Prop({ required: true })
  isAlteracao!: boolean;

  tiposPrestador = tiposPrestadorList;
  oldCpfCnpj = '';

  updated() {
    if (!!!this.oldCpfCnpj) {
      this.oldCpfCnpj = this.dadosBasicos.cpfCnpj;
    }
  }

  validar(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.dadosBasicos.telefones.length < 1) {
        this.$refs.telefones.$refs.telefoneObserver.setErrors({
          "Tipo de telefone": "É necessário incluir ao menos um telefone",
          "Número de telefone": " ",
        });
      }
      this.$refs.dadosBasicosObserver
        .validate()
        .then((valid: boolean) => {
          if (valid) {
            valid = this.dadosBasicos.telefones.length > 0;
          }
          resolve(valid);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  scrollToError() {
    const errors = Object.entries(this.$refs.dadosBasicosObserver.refs)
      .map(([key, value]) => ({
        key,
        value,
      }))
      .filter((error) => {
        if (!error || !error.value || !error.value.failedRules) return false;
        return Object.keys(error.value.failedRules).length > 0;
      });
    if (errors && errors.length > 0) {
      this.$refs.dadosBasicosObserver.refs[errors[0]["key"]].$el.scrollIntoView(
        {
          behavior: "smooth",
          block: "center",
        }
      );
    }
  }

  verificarDocCadastrado() {
    console.log(this.isAlteracao, this.oldCpfCnpj, this.dadosBasicos.cpfCnpj);
    if ((this.isAlteracao && this.oldCpfCnpj != this.dadosBasicos.cpfCnpj) || (!this.isAlteracao)) {
      this.DocProvider.validate().then((validationResult: ValidationResult) => {
        if (validationResult.valid) {
          this.dadosBasicos.tipoPessoa = DadosBasicosController.tipoPessoa(this.dadosBasicos.cpfCnpj);
          cadastroPrestadorService
            .verificarCNPJCadastrado(this.dadosBasicos.cpfCnpj.replace(/\D/g, ""))
            .then((existe: boolean) => {
              if (existe) {
                const doc = this.isPF ? 'CPF' : 'CNPJ';
                this.DocProvider.setErrors([`${doc} já cadastrado no sistema.`]);
              }
            });
        }
      });
    }
  }

  public get isPF(): boolean {
    return DadosBasicosController.isPF(this.dadosBasicos.cpfCnpj)
  }
}
